const routes = [
    {
        path: '/gestao_cobrancas/*',
        beforeEnter: (to) => {
            const novaUrl = '/financeiro' + to.fullPath
            window.location.href = novaUrl 
        }
    },
]
export default routes
